import secureLocalStorage from 'react-secure-storage';
import CryptoJS from 'crypto-js';
import { AES } from 'crypto-js';

export const setItem = (key, value) => {
  return secureLocalStorage.setItem(key, value);
};

export const getItem = (key) => {
  return secureLocalStorage.getItem(key);
};

export const removeItem = (key) => {
  return secureLocalStorage.removeItem(key);
};

export const clearItem = () => {
  return secureLocalStorage.clear();
};

export const encryptData = (data) => {
  const publiCKey = process.env.REACT_APP_ENCRYPT_PUBLIC_KEY;
  const ivKey = process.env.REACT_APP_ENCRYPT_IV_KEY;
  const key = CryptoJS.enc.Hex.parse(publiCKey);
  const ivHex = CryptoJS.enc.Hex.parse(ivKey);
  const encryptData = JSON.stringify(data);
  const dataToEncrypt = CryptoJS.enc.Utf8.parse(encryptData);
  const encrypted = CryptoJS.AES.encrypt(dataToEncrypt, key, {
    iv: ivHex,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  const encryptedHex = encrypted.ciphertext.toString(CryptoJS.enc.Hex);
  return encryptedHex;
};

export const decryptData = (data) => {
  const publiCKey = process.env.REACT_APP_ENCRYPT_PUBLIC_KEY;
  const ivKey = process.env.REACT_APP_ENCRYPT_IV_KEY;
  const secretKey = CryptoJS.enc.Hex.parse(publiCKey);
  const secretIv = CryptoJS.enc.Hex.parse(ivKey);
  const encryptedData = CryptoJS.enc.Hex.parse(data);
  var decrypt = AES.decrypt(
    {
      ciphertext: encryptedData,
      salt: '',
    },
    secretKey,
    {
      iv: secretIv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );
  const response = decrypt.toString(CryptoJS.enc.Utf8);
  const jsonResponse = JSON.parse(response);
  return jsonResponse;
};

export const encryptedLocalStorage = (key, value) => {
  const encryptedValue = encryptData(value);
  return localStorage.setItem(key, encryptedValue);
};
export const decryptDataLocalStorage = (key) => {
  const value = localStorage.getItem(key);
  const decryptedValue = decryptData(value);
  return decryptedValue;
};

export const setCookie = (name, value, hours) => {
  const encryptedValue = encryptData(value);
  const expires = new Date();
  expires.setTime(expires.getTime() + hours * 60 * 60 * 1000);
  const cookie = `${name}=${encryptedValue};expires=${expires.toUTCString()};path=/`;
  document.cookie = cookie;
};

// Function to get a cookie value by name
export const getCookie = (name) => {
  const cookies = document.cookie.split('; ');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].split('=');
    if (cookie[0] === name) {
      const decryptedValue = decryptData(cookie[1]);
      return decryptedValue;
    }
  }
  return null;
};

// Function to remove a cookie by name
export const removeCookie = (name) => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
};

export const setDataInSessionStorage = (key, data) => {
  const encryptedValue = encryptData(data);
  return sessionStorage.setItem(key, JSON.stringify(encryptedValue));
};

export const getDataFromSessionStorage = (key) => {
  const storedData = sessionStorage.getItem(key);
  if (storedData) {
    const decryptedValue = decryptData(JSON.parse(storedData));
    return decryptedValue;
  } else {
    return JSON.parse(storedData);
  }
};

export const clearDataInSessionStorage = (key) => {
  if (key) {
    sessionStorage.removeItem(key);
  } else {
    sessionStorage.clear();
  }
};
